<mat-card class="task-card" (click)="onTaskClick()">
  <div class="priority-bar" [style.background-color]="getPriorityColor(task.priority)"></div>
  <div class="task-content">
    <h3>{{ task.title }}</h3>
    <p>Data alvo: {{ task.targetDate | date:'dd/MM/yyyy' }}</p>
  </div>
</mat-card>
